import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import AlertCmp from './components/shared/Alert.vue'
import axios from 'axios'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueGtag from 'vue-gtag';
import Meta from 'vue-meta'

Vue.use(Meta)

Vue.use(VueGtag, {
  config: {
    id: 'UA-111468086-1',
    params: {
      anonymize_ip: true
    }
  },
  bootstrap: false
}, router)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCKxduOxkLT7wn4IKNf1PzaNMMVt0S1hzM',
    libraries: 'places',
    language: 'de'
  }
})

axios.defaults.baseURL = 'https://api2.urlaubimwaldviertel.at/api'
// axios.defaults.baseURL = 'http://127.0.0.1:8000/api'
axios.defaults.withCredentials = true
axios.defaults.withXSRFToken = true
// axios.defaults.headers.common['Authorization'] =
//  'Bearer ' + localStorage.getItem('token')
axios.defaults.headers.get['Accepts'] = 'application/json'

// Require the main Sass manifest fil
require('./assets/sass/main.scss')

Vue.config.productionTip = false

Vue.component('app-alert', AlertCmp)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
